<template>
  <div class="chat-history-root">
    <!-- Élément cliquable -->
    <div class="chat-item" @click="goToChat">
      <img class="avatar" src="@/assets/pp.png" />
      <div class="content">
        <div class="top-row">
          <span class="name">{{ name }}</span>
        </div>
        <div class="bottom-row">
          <div class="message-info">
            <span class="message">{{ lastMessage || 'Aucun message' }}</span>
            <span class="time">{{ lastTime || '' }}</span>
          </div>
          <div class="badge" v-if="unreadCount > 0">{{ unreadCount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ChatHistory',
  data() {
    return {
      name: '',
      unreadCount: 0,
      lastMessage: '',
      lastTime: '',
    };
  },
  mounted() {
    this.fetchChatData();
  },
  methods: {
    async fetchChatData() {
      try {
        const response = await axios.post('/api/v1/home/check_chat/');
        const data = response.data;
        this.name = data.name;
        this.unreadCount = data.unread || 0;
        if (data.last_messages.length > 0) {
          this.lastMessage = data.last_messages[1].last_message;
          this.lastTime = data.last_messages[1].last_message_time;
        } else {
          this.lastMessage = '';
          this.lastTime = '';
        }
      } catch (error) {
        console.error('Erreur lors du chargement des messages :', error);
      }
    },
    goToChat() {
      this.$router.push({ name: 'dashboard.chat', params: { count: this.unreadCount } });
    },
  },
};
</script>

<style scoped>
.chat-history-root {
  padding: 10px;
}

.chat-item {
  display: flex;
  padding: 10px;
  align-items: center;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.chat-item:hover {
  background-color: #f5f5f5;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.content {
  flex: 1;
  margin-left: 10px;
}

.top-row {
  display: flex;
  justify-content: space-between;
}

.name {
  font-weight: bold;
  font-size: 16px;
}

.bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.message-info {
  display: flex;
  flex-direction: column;
}

.message {
  color: #444;
  font-size: 14px;
}

.time {
  font-size: 12px;
  color: #888;
}

.badge {
  background: green;
  color: white;
  border-radius: 50%;
  padding: 4px 8px;
  font-size: 0.8em;
}

</style>
